import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const BeigabenArtikelServiceConfig = {
  name: "BeigabenArtikel",
  annotations: []
} as ServiceConfig;